// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__1TmC1","settings_card":"index_settings_card__HBeXv"};